import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { SendingToFinance, ApiGateway } from "cw-backend";
import { SnackBarService } from "cw-utils";

@Injectable()
export class SendingToFinanceEditProvider implements Resolve<any> {
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    sendingToFinance: SendingToFinance;

    constructor(public gw: ApiGateway, public snackBar: SnackBarService) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([this.getSendingToFinance()]).then(() => {
                resolve(true);
            }, reject);
        });
    }

    getSendingToFinance(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data = this.checkLastModifications();
            if (data && data.id == this.routeParams.id) {
                this.sendingToFinance = data;
                this.onDataChanged.next(this.sendingToFinance);
                resolve(this.sendingToFinance);
            } else if (this.routeParams.id === "novo") {
                this.onDataChanged.next(false);
                resolve(false);
            } else {
                this.gw
                    .get("sendingToFinance/" + this.routeParams.id)
                    .subscribe({
                        next: (res: SendingToFinance) => {
                            this.sendingToFinance = res;
                            this.onDataChanged.next(this.sendingToFinance);
                            resolve(res);
                        },
                        error: (err: any) => {
                            reject(err);
                        },
                    });
            }
        });
    }

    insert(sendingToFinance): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("sendingToFinance/", sendingToFinance).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    edit(sendingToFinance): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("sendingToFinance/", sendingToFinance).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    delete(sendingToFinance): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .delete("sendingToFinance/" + sendingToFinance.id)
                .subscribe({
                    next: (response: HttpResponse<any>) => {
                        resolve(response);
                        this.snackBar.successMessage(response.body.message);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    checkLastModifications(): SendingToFinance {
        let wasLocked = JSON.parse(localStorage.getItem("session_locked"));
        let data;
        if (wasLocked) {
            data = JSON.parse(localStorage.getItem("last_modification"));
            localStorage.removeItem("session_locked");
        }
        return data;
    }

    processSendingToFinance(filterTo: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("sendingToFinance/process", filterTo).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                    this.snackBar.successMessage(res.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    finishSendingToFinance(sendingToFinance): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post("sendingToFinance/finish/" + sendingToFinance.id, {})
                .subscribe({
                    next: (response: HttpResponse<any>) => {
                        resolve(response);
                        this.snackBar.successMessage(response.body.message);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    cancelProcessing(sendingToFinance): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .delete("sendingToFinance/process/" + sendingToFinance.id)
                .subscribe({
                    next: (response: HttpResponse<any>) => {
                        resolve(response);
                        this.snackBar.successMessage(response.body.message);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    cancelProcessingItem(sendingToFinanceId: number, orderPayId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .delete(
                    "sendingToFinance/process/" +
                        sendingToFinanceId +
                        "/item/" +
                        orderPayId,
                )
                .subscribe({
                    next: (response: HttpResponse<any>) => {
                        resolve(response);
                        this.snackBar.successMessage(response.body.message);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    reversal(sendingToFinance): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .delete("sendingToFinance/reversal/" + sendingToFinance.id)
                .subscribe({
                    next: (response: HttpResponse<any>) => {
                        resolve(response);
                        this.snackBar.successMessage(response.body.message);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }
}
